import { useMctFlags } from "./useMctFlags";

export function useMgovRedesignClass() {
  const { tmpFeEnableMgovReskin } = useMctFlags();
  return tmpFeEnableMgovReskin ? "mgov-redesign-block" : "";
}
